import { render, staticRenderFns } from "./catchCopy.vue?vue&type=template&id=ab4feeac&"
import script from "./catchCopy.vue?vue&type=script&lang=js&"
export * from "./catchCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports